import { Box, Typography } from "@mui/material";
import { Sidebar } from "./Sidebar";
import PostsAndSearch from "./inspiration/components/PostsandSearch";

export default function InspirationSearch() {

  return (
    <Box display="flex" height="100vh">
      <Sidebar selected="search" />
    
      <Box display="flex" flexDirection="column" flexGrow={1} >
        <PostsAndSearch />
      </Box>
    </Box>
  );
}
